import { SDLUtil, RequestUtil, StringUtil } from '@/utils';

const setSystemTransitionDivisionInfo = ({ commit }, data) => {
  commit('SET_SYSTEM_TRANSITION_DIVISION_INFO', data);
};

const setSystemTransitionData = ({ commit }, data) => {
  commit('SET_SYSTEM_TRANSITION_DATA', data);
};

const setIamUserData = ({ commit }, data) => {
  commit('SET_IAM_USER_DATA', data);
};

const setAdminYn = ({ commit }, data) => {
  commit('SET_ADMIN_YN', data);
};

const setCutOverStatus = ({ commit }, data) => {
  commit('SET_CUT_OVER_STATUS', data);
};

const setSearchParamWithRoute = ({ commit }, data) => {
  commit('UPDATE_SEARCH_PARAMS', data);
};

const setRouteInit = ({ commit }, data) => {
  commit('SET_UPDATE_ROUTE_INIT', data);
};

export default {
  async SEARCH_SYSTEM_TRANSITION_DIVISION(store) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/cop/std/systemTransition/selectDivisionList`);
    setSystemTransitionDivisionInfo(store, data.data);
  },
  async SEARCH_SYSTEM_TRANSITION_DATA(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/cop/std/systemTransition/selectSystemTransitionList?${StringUtil.queryStringfy(param)}`);
    setSystemTransitionData(store, data.data);
  },
  async SEARCH_IAM_USER_DATA(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/cop/std/systemTransition/selectIamUserList?${StringUtil.queryStringfy(param)}`);
    setIamUserData(store, data.data);
  },
  async SAVE_SYSTEM_TRANSITION(store, param) {
    await RequestUtil.post(`${SDLUtil.API_URL}/cop/std/systemTransition/saveSystemTransition`, param);
  },
  async SAVE_DESCRIPTION(store, param) {
    await RequestUtil.post(`${SDLUtil.API_URL}/cop/std/systemTransition/saveDescription`, param);
  },
  async SEARCH_ADMIN_YN(store) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/cop/std/systemTransition/selectAdminYn`);
    setAdminYn(store, data.data);
  },
  async GET_CUT_OVER_STATUS(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/cop/std/systemTransition/selectCutOverStatus?${StringUtil.queryStringfy(param)}`);
    setCutOverStatus(store, data.data);
  },
  SET_SEARCH_PARAM_WITH_ROUTE(store, param) {
    setSearchParamWithRoute(store, param);
  },
  SET_ROUTE_INIT(store, param) {
    setRouteInit(store, param);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/systemTransition/systemTransitionAction.js